/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;

  path {
    fill: none;
  }
`
export default class MagnifyingGlassIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="13.426" height="12.472" viewBox="0 0 13.426 12.472" css={Color} className="magnifying-glass-icon">
        <g id="그룹_7121" data-name="그룹 7121" transform="translate(0.5 0.5)">
          <path id="패스_4309" data-name="패스 4309"
                d="M1069.283,130.769a5.357,5.357,0,1,1,5.358-5.357A5.363,5.363,0,0,1,1069.283,130.769Zm0-10.133a4.776,4.776,0,1,0,4.776,4.776A4.781,4.781,0,0,0,1069.283,120.635Z"
                transform="translate(-1063.926 -120.054)" stroke="#000" strokeWidth="1"/>
          <path id="패스_4311" data-name="패스 4311"
                d="M1125.334,185.128a.388.388,0,0,1-.265-.1l-2.645-2.466a.388.388,0,1,1,.529-.568l2.646,2.466a.388.388,0,0,1-.265.672Z"
                transform="translate(-1113.296 -173.657)" stroke="#000" strokeWidth="1"/>
        </g>
      </svg>
    )
  }
}
